import React, { useEffect } from 'react';
import ArchiveWrapper from '../../components/shared/ArchiveWrapper';

const Archive2022: React.FC = () => {
  useEffect(() => {
    // タイトルを設定
    document.title = '第55回かまた祭2022 アーカイブサイト | かまた祭公式ホームページ';

    // メタディスクリプションを設定
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '本ページは過去のかまた祭のアーカイブページです。');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = '本ページは過去のかまた祭のアーカイブページです。';
      document.head.appendChild(meta);
    }

    // クリーンアップ
    return () => {
      document.title = 'かまた祭';
    };
  }, []);

  return <ArchiveWrapper year="2022" url="/archive/wp22/index.html" />;
};

export default Archive2022;
